import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Email question component.
 * Displays and configures an email input question with validation.
 * Uses Angular signals inherited from BaseQuestionComponent.
 */
@Component({
  selector: 'app-email-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './email-question.component.html',
  styleUrl: './email-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailQuestionComponent extends BaseQuestionComponent implements OnInit {
  placeholder: string = '';
  emailValue: string = '';
  emailError: string = '';

  ngOnInit(): void {
    // Hydrate the stored placeholder so loaded templates render/edit it
    // (matches textbox/textarea/phone behaviour).
    this.placeholder = this.question().placeholder || '';
  }

  onLabelChange(value: string): void {
    this.updateLabel(value);
  }

  onPlaceholderChange(value: string): void {
    this.placeholder = value;
    this.emitConfigChange({ placeholder: this.placeholder } as any);
  }

  onHelperTextChange(value: string): void {
    this.updateHelperText(value);
  }

  onAdditionalInfoChange(value: string): void {
    this.updateAdditionalInfo(value);
  }

  onEmailChange(value: string): void {
    this.emailValue = value;
    this.validateEmail(value);
  }

  onEmailBlur(): void {
    if (this.emailValue) {
      this.validateEmail(this.emailValue);
    } else {
      this.emailError = '';
    }
  }

  private validateEmail(email: string): void {
    if (!email) {
      this.emailError = '';
      return;
    }

    // Email validation regex pattern
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(email)) {
      this.emailError = 'Please enter a valid email address';
    } else {
      this.emailError = '';
    }
  }

  isValidEmail(): boolean {
    return !this.emailError && this.emailValue.length > 0;
  }

  onRequiredToggle(): void {
    this.updateRequired(!this.question().isRequired);
  }
}
